import { render, staticRenderFns } from "./DocomoBusstopMarker.vue?vue&type=template&id=574bcba1&"
import script from "./DocomoBusstopMarker.vue?vue&type=script&lang=js&"
export * from "./DocomoBusstopMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports